import "./subHeader.css";

import styled from "styled-components";
import { NavLink } from "react-router-dom";
import 회사소개 from "../pages/img/subheader/subheader1.jpg";
import i18next from "../config/lang/i18next";

const StyledLink = styled(NavLink)`
width:20%;
cursor:pointer;
display: inline-block;
font-size:1.2rem;
border-right:1px solid gray;

`;

const subHeader = () => (
  <div className="container_header">
    <style>
      {`

  
  @media (max-width: 700px) {
	.none, .selected {
		width: 25%;
		
	}
  }
`}
    </style>
    <div className="sub_header subheader1" style={{ backgroundImage: `url(${회사소개})`, backgroundSize:"cover" }}>
      <div className="sub_header_txt">
        <h2>About GM Medical</h2>
        <hr></hr>
        <h3>Everything About GM Medical</h3>
      </div>

      <div className="ul_wrapper fixed">
        <ul className="menu_container clearfix">
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/ceo"
          >
            <li>{i18next.t("navbar.1-1")}</li>
          </NavLink>
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/history"
          >
            <li>{i18next.t("navbar.1-2")}</li>
          </NavLink>
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/location"
          >
            <li>{i18next.t("navbar.1-3")}</li>
          </NavLink>
    
        </ul>
      </div>
    </div>
  </div>
);

export default subHeader;
